<template>
	<el-dialog :visible.sync="showdownwin" title="下载订单" width="600px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
		<div class="downmd">
			<el-form size="mini" :inline="true">
				<el-form-item label="所属系统">
					<el-select v-model="info.ds_code" :clearable="true" style="width:180px">
						<el-option v-for="item in dslist" :key="item.ds_code" :label="item.ds_name" :value="item.ds_code">
							<span style="float: left">{{ item.ds_name }}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户账号">
					<el-autocomplete
						ref="u_account"
						:trigger-on-focus="false"
						v-model="info.u_account"
						:fetch-suggestions="searchvip"
						placeholder="请输入账号\姓名"
						@select="checkuser"
						value-key="u_account"
						size="small"
						@change="val => changeuser(val)"
					>
						<template slot-scope="{ item }">
							<div>{{ item.u_name }} ({{ item.u_account }} )</div>
						</template>
					</el-autocomplete>
				</el-form-item>
			</el-form>
			<el-form size="mini">
				<el-form-item label="">
					<el-input
						:rows="13"
						type="textarea"
						style="overflow-y:auto;margin-top:10px"
						v-model="info.expressid"
						placeholder="请输入快递单号,多个单号换行输入"
						@keyup.native="event => BtnState(event)"
					></el-input>
				</el-form-item>
			</el-form>
			<div>
				<div>
					<span v-if="allcount>0">共输入{{ allcount }}个单号</span>
					<span v-if="yxcount>0" style="margin-left:10px;color:#0066CC;">其中{{ yxcount }}个有效单号</span>
					<span v-if="handlercount>0" style="margin-left:10px;color:#008A00;">已处理{{ handlercount }}个订单</span>
				</div>
				<div v-if="downsuccess">
					<span v-if="yxcount==handlercount&&handlercount>0">已全部下载完成</span>
					<span style="margin-left:10px" v-if="filename != ''"><a href="#" @click="downfile">下载错误的订单</a></span>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<div style="text-align: center;">
				<el-button type="success" @click="suredownorder" :disabled="btndisabled">{{ btntitle }}</el-button>
				<el-button  @click="canceldown">取消</el-button>
			</div>
		</span>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			showdownwin: false,
			btntitle: '开始下载',
			btndisabled: false,
			batch: '',
			info: {
				ds_code: '',
				expressid: '',
				u_account: '',
				u_userid: ''
			},
			handlercount: 0,
			allcount: 0,
			yxcount:0,
			filename: '',
			dslist: [],
			divclass: 'downmd',
			downsuccess: false,
			timer:0
		};
	},
	mounted() {},
	methods: {
		init(param) {
			//debugger
			this.handlercount = 0;
			this.allcount = 0;
			this.filename = '';
			this.batch = '';
			this.btntitle = '开始下载';
			this.btndisabled = true;
			this.downsuccess = false;
			this.yxcount=0;
			this.info={
				ds_code: '',
				expressid: '',
				u_account: '',
				u_userid: ''
			},
			this.loadUserds();
		},
		loadUserds() {
			var that = this;
			this.$tool.loading('正在加载', this.divclass);
			this.$apipost.get.GetUserDsList({ paraminfo: { type: '下载订单' } }).then(res => {
				this.$tool.loadingclose();
				if (res.list != undefined) {
					that.dslist = res.list;
					if (that.dslist.length > 0) {
						that.showdownwin = true;
						if (that.dslist.length == 1) that.info.ds_code = that.dslist[0].ds_code;
					} else this.$tool.message('无平台可下载订单', 0);
				} else this.$tool.message('无平台可下载订单', 0);
			});
		},
		BtnState(){
			if(this.info.u_userid==''||this.info.ds_code==''||this.info.expressid=='')
				this.btndisabled=true;
			else{
				this.btndisabled=false;
			}
			var that=this;
			if(this.info.expressid!=''){
				var list=this.info.expressid.split('\n');
				var empty=list.filter(function(e){
					return e=='';
				});
				if(empty.length==list.length){
					that.btndisabled=true;
					this.info.expressid='';
				}else
					this.allcount=list.length-empty.length;
			}
		},
		GetSearchObj() {
			var searchinfo = {
				searchbox: this.info.u_account
			};
			return searchinfo;
		},
		checkuser(val) {
			this.info.u_userid = val.u_userid;
			this.info.u_account = val.u_account;
			this.BtnState();
		},
		searchvip(val, cb) {
			var that = this;
			setTimeout(function() {
				if (val != '') {
					//获取会员卡列表
					var paraminfo = {
						mode: '会员列表',
						tab: '',
						search: that.GetSearchObj(),
						pageindex: 0,
						pagesize: 20,
						sort: '',
						iscount: 0,
						showcol: ''
					};
					that.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
						cb(res.data);
					});
				} else {
					this.info.u_account = '';
					this.info.u_userid = '';
					this.BtnState();
				}
			}, 300);
		},
		changeuser(val) {
			this.info.u_account = '';
			this.info.u_userid = '';
			this.BtnState();
		},
		//开始下载
		suredownorder() {
			var that = this;
			var allcount=this.allcount;
			if(this.yxcount==0){
				that.btndisabled = true;
				that.btntitle = '下载中';
			}
			else
				allcount=this.yxcount;
			var paraminfo = {
				info: this.info,
				batch: this.batch,
				allcount:allcount,
				handlercount:this.handlercount,
				handleraccount: localStorage.getItem('u_account')
			};
			this.$apipost.post.DownSysOrder({ paraminfo: paraminfo }).then(res => {
				that.btndisabled = false;
				if (res.state == '1') {
					this.$tool.message('全部下载完成', 1);
					that.downsuccess=true;
					setTimeout(function() {
						that.canceldown();
					}, 200);
				} else {
					//debugger
					if (res.batch != undefined) that.batch = res.batch;
					if (res.allcount != undefined) that.yxcount = res.allcount;
					if (res.handlercount != undefined) that.handlercount = res.handlercount;
					if (res.filename != undefined) that.filename = res.filename;
					if (res.message != undefined) this.$tool.message(res.message, 0);

					if(that.filename!=''){
						that.downsuccess=true;
						that.btntitle = '处理完成';
					}
				}
			});
		},
		//关闭窗口
		canceldown() {
			var that = this;
			if (this.batch != '' && !this.downsuccess) {
				this.$confirm('订单下载未完成，确定取消?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						that.showdownwin = false;
					})
					.catch(() => {});
			} else{
				this.showdownwin = false;
				this.$parent.refreshgrid(true);
			}
		},
		downfile(){
			if(this.filename!=''){
				this.$tool.downfile(this,this.filename,this.batch);
			}
		}		
	}
};
</script>

<style></style>
